namespace $ {
	export type $shm_hitalama_components_demo_result = { component: $mol_view }
	/** Demo source supplies test data directly to the rendered preview. */
	export class $shm_hitalama_components_demo extends $mol_object {
		definition() { return null as any as $shm_hitalama_map_widget_entity_custom }
		extra_context(): Record< string, any > { return {} }
		source_text( kind: string ) { return this.definition().source_text( kind as $shm_hitalama_map_widget_entity_custom_source_kind ) }
		@ $mol_mem
		mocked( next?: boolean ) {
			this.definition()
			return next ?? true
		}
		kind(): string { return this.mocked() ? 'demo' : 'default' }
		@ $mol_mem
		loader() { return new this.$.$shm_hitalama_map_component }
		@ $mol_mem
		context() {
			// Preserve lazy runtime values without reading them
			// while constructing a component's scope.
			const scope = Object.create( this.$, Object.getOwnPropertyDescriptors( this.extra_context() ) )
			scope.$ = scope
			scope.$$ = scope
			scope[ '$' + 'component' ] = this.$.$shm_hitalama_map_component_factory( this.loader() )
			scope[ '$' + 'make' ] = this.$.$shm_hitalama_map_runtime_make
			return scope
		}
		result(): $shm_hitalama_components_demo_result | null {
			return this.result_for( this.kind() )
		}
		@ $mol_mem_key
		result_for( kind: string ): $shm_hitalama_components_demo_result | null {
			// A mode change starts a fresh local demo instead of retaining stale state.
			if( kind === 'demo' ) this.mocked()
			const definition = this.definition()
			this.$.$shm_hitalama_map_component_ready.read( definition )
			if( kind !== 'demo' && kind !== 'default' ) throw new Error( 'Неизвестный способ запуска модуля.' )
			const source = definition.source_link( kind )
			if( source ) this.$.$shm_hitalama_map_component_ready.read( source )
			// A service/model has no implicit UI demo: opening its editor must not
			// instantiate it or run its constructor as a side effect.
			if( kind === 'demo' && !source ) {
				const tree = definition.source_link( 'tree' )
				if( tree ) this.$.$shm_hitalama_map_component_ready.read( tree )
				if( !definition.source_text( 'tree' ).trim() ) return null
			}
			const demo = this.source_text( kind )
			if( !demo.trim() ) return null
			return this.result_source( JSON.stringify([ definition.class_name(), kind, demo ]) )
		}

		@ $mol_mem_key
		result_source( signature: string ): $shm_hitalama_components_demo_result | null {
			const [ name, kind, demo ] = JSON.parse( signature ) as [ string, string, string ]
			if( kind === 'demo' ) this.mocked()
			const compiler = this.loader().compiler()
			const output = compiler.compiled( compiler.signature({
				fqn: name, tree: name + ' $mol_view\n',
				logic: 'function demo(){\n' + demo + '\n}', style: '', format: 'ts',
			}) )
			const scope = this.context()
			const aliases = output.bindings.logic.filter( name => name in scope )
				.map( name => `const ${ name } = $[${ JSON.stringify( name ) }];` ).join( '\n' )
			const run = new Function( '$', '"use strict";\n' + aliases + '\n' + output.logic + '\nreturn demo();' )
			const value = run( scope )
			const result = value instanceof this.$.$mol_view ? { component: value } : value
			if( !result || !( result.component instanceof this.$.$mol_view ) || 'form' in result ) {
				throw new Error( `${ kind }.ts должен вернуть $mol_view или { component: $mol_view }. Тестовые данные задаются в коде запуска.` )
			}
			return Object.assign( { component: result.component }, {
				destructor: ()=> result.component.destructor(),
			} )
		}
	}
}
